/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import moment from "moment";
import { CALENDAR_HEADER } from "../../constants/DAY";
import { forEach, get } from "lodash-es";
import { dateToFormat } from "../../utils/date";
import Icon from "../Icon";
import { WORK_SCHEDULE_EVENT } from "../../constants/WORK_SCHEDULE_EVENT";
import classnames from "classnames";
import { isEmpty } from "../../utils/lodashExtend";
import Button from "../Button";
import ToolTip from "../ToolTip/ToolTip";

const Calendar = ({ event, onMonthChage, forwardedRef, eventClick,
  type = "",
  className = ""
}) => {
  const calendarRef = useRef();
  const yearRef = useRef();
  const monthRef = useRef();
  const holidayArray = [];

  const pre = () => {
    let calendarApi;
    if (isEmpty(forwardedRef)) {
      calendarApi = calendarRef.current.getApi();
    } else {
      calendarApi = forwardedRef.current.getApi();
    }
    calendarApi.prev();
  };

  const next = () => {
    let calendarApi;
    if (isEmpty(forwardedRef)) {
      calendarApi = calendarRef.current.getApi();
    } else {
      calendarApi = forwardedRef.current.getApi();
    }
    calendarApi.next();
  };

  const today = () => {
    let calendarApi;
    if (isEmpty(forwardedRef)) {
      calendarApi = calendarRef.current.getApi();
    } else {
      calendarApi = forwardedRef.current.getApi();
    }
    calendarApi.today();
  };

  useEffect(() => {
    forEach(event, (ev) => {
      if (ev.className === "holiday") {
        holidayArray.push(dateToFormat(ev.start));
      }
    });
  }, [event]);

  return (
    <div className={classnames("calendar-wrap", className)}>
      <div className="calendar-header">
        <p ref={yearRef} className="year">
          {new Date().getFullYear()}
        </p>
        <p ref={monthRef} className="month">
          {new Date().getMonth() + 1}월
        </p>
        <Button
          label="오늘"
          color="gray-line"
          className="today-button"
          size="sm"
          action={today}
        />
        <div className="calendar-button-wrap">
          <button className="calendar-button pre" onClick={pre}>
            <span className="pre" />
          </button>
          <button className="calendar-button next" onClick={next}>
            <span className="next" />
          </button>
        </div>
      </div>
      <FullCalendar
        ref={forwardedRef || calendarRef}
        initialView="dayGridMonth"
        plugins={[dayGridPlugin]}
        headerToolbar={false}
        titleFormat={(date) => {
          const year = yearRef.current;
          const month = monthRef.current;
          if (year) year.innerText = date.date.year;
          if (month) month.innerText = `${date.date.month + 1}월`;
        }}
        dayHeaderFormat={(date) => {
          let translate = "";
          const data = moment(date.date).format("dd");
          const list = CALENDAR_HEADER;
          const result = list.find((item) => item["value"] === data);
          translate = result ? result["label"] : data;
          return translate;
        }}
        dayCellClassNames={(date) => {
          if (holidayArray && holidayArray.includes(dateToFormat(date.date))) {
            return "holiday";
          }
        }}
        displayEventTime={false}
        events={event}
        eventContent={(eventInfo) => renderEventContent(eventInfo, type)}
        datesSet={(datesSet) => {
          onMonthChage && onMonthChage(datesSet);
        }}
        eventClick={eventClick}
      />
    </div>
  );
};

const renderEventContent = (eventInfo, type) => {
  const eventObj = WORK_SCHEDULE_EVENT.find(
    (work) => work.key === get(eventInfo, "event.classNames[0]") || ""
  );
  const title = eventInfo.event.title.split("-");
  const color = eventInfo.event?.extendedProps?.categoryColor;

  const position = eventInfo?.event?.extendedProps?.tooltip;

  return (
    <>
      {type === "tax-portal" ? (
        <ToolTip
          tooltiptext={title.join('-')}
          position={position}
          className={"calandar-tooltip"}
        >
          <span
            style={{
              background: color,
              width: "10px",
              height: "10px",
              borderRadius: "50%",
              display: "inline-block",
            }}
          />
        </ToolTip>
      ) : (
        <>
          <Icon src={get(eventObj, "icon")} className="custom-event-icon" />
          <span className="custom-event-title">
            <span
              className={classnames("start", {
                "color-red-100":
                  get(eventInfo, "event.extendedProps.isLate") ||
                  get(eventInfo, "event.extendedProps.isAbsence"),
              })}
            >
              {title[0]}
            </span>
            {!(
              get(eventInfo, "event.extendedProps.isAbsence") ||
              get(eventInfo, "event.extendedProps.isVacation")
            ) && !isEmpty(title[1]) && (
                <>
                  <span>-</span>
                  <span
                    className={classnames("end", {
                      "color-red-100": get(
                        eventInfo,
                        "event.extendedProps.isEarlyLeft"
                      ),
                      "color-orange-100": get(
                        eventInfo,
                        "event.extendedProps.isCommuteError"
                      ),
                    })}
                  >
                    {title[1]}
                  </span>
                </>
              )}
          </span>
        </>
      )}
    </>
  );
};

export default Calendar;
